"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mean = void 0;
var sum_1 = require("./sum");
var mean = function (n_array) { return sum_1.default(n_array) / n_array.length; };
exports.mean = mean;
exports.default = exports.mean;
